<template lang="pug">
  tbody
    tr
      th(rowspan=3) {{ $t("ui.sportsbook") }}
      th {{ soccer_hdp_title }}
      td
        PTSelect(
          ref="soccer_hdp_upline_pt"
          :dirty="$v.soccer_hdp_upline_pt.$dirty"
          :error="$v.soccer_hdp_upline_pt.$error"
          :options="soccer_hdp_upline_options"
          :value="soccer_hdp_upline_pt"
          @input="input_soccer_hdp_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="soccer_hdp_account_pt"
          :dirty="$v.soccer_hdp_account_pt.$dirty"
          :error="$v.soccer_hdp_account_pt.$error"
          :options="soccer_hdp_account_options"
          :value="soccer_hdp_account_pt"
          @input="input_soccer_hdp_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="soccer_hdp_upline_remaining"
          :dirty="$v.soccer_hdp_upline_remaining.$dirty"
          :error="$v.soccer_hdp_upline_remaining.$error"
          :options="soccer_hdp_account_options"
          :value="soccer_hdp_upline_remaining"
          @input="input_soccer_hdp_upline_remaining"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="soccer_hdp_account_min"
          :dirty="$v.soccer_hdp_account_min.$dirty"
          :error="$v.soccer_hdp_account_min.$error"
          :options="soccer_hdp_min_options"
          :value="soccer_hdp_account_min"
          @input="input_soccer_hdp_account_min"
          :disabled="loading"
        )
    tr
      th {{ soccer_1x2_title }}
      td
        PTSelect(
          ref="soccer_1x2_upline_pt"
          :dirty="$v.soccer_1x2_upline_pt.$dirty"
          :error="$v.soccer_1x2_upline_pt.$error"
          :options="soccer_1x2_upline_options"
          :value="soccer_1x2_upline_pt"
          @input="input_soccer_1x2_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="soccer_1x2_account_pt"
          :dirty="$v.soccer_1x2_account_pt.$dirty"
          :error="$v.soccer_1x2_account_pt.$error"
          :options="soccer_1x2_account_options"
          :value="soccer_1x2_account_pt"
          @input="input_soccer_1x2_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="soccer_1x2_upline_remaining"
          :dirty="$v.soccer_1x2_upline_remaining.$dirty"
          :error="$v.soccer_1x2_upline_remaining.$error"
          :options="soccer_1x2_account_options"
          :value="soccer_1x2_upline_remaining"
          @input="$v.soccer_1x2_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="soccer_1x2_account_min"
          :dirty="$v.soccer_1x2_account_min.$dirty"
          :error="$v.soccer_1x2_account_min.$error"
          :options="soccer_1x2_min_options"
          :value="soccer_1x2_account_min"
          @input="$v.soccer_1x2_account_min.$model = $event"
          :disabled="loading"
        )
    tr
      th {{ soccer_others_title }}
      td
        PTSelect(
          ref="soccer_others_upline_pt"
          :dirty="$v.soccer_others_upline_pt.$dirty"
          :error="$v.soccer_others_upline_pt.$error"
          :options="soccer_others_upline_options"
          :value="soccer_others_upline_pt"
          @input="input_soccer_others_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="soccer_others_account_pt"
          :dirty="$v.soccer_others_account_pt.$dirty"
          :error="$v.soccer_others_account_pt.$error"
          :options="soccer_others_account_options"
          :value="soccer_others_account_pt"
          @input="input_soccer_others_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="soccer_others_upline_remaining"
          :dirty="$v.soccer_others_upline_remaining.$dirty"
          :error="$v.soccer_others_upline_remaining.$error"
          :options="soccer_others_account_options"
          :value="soccer_others_upline_remaining"
          @input="$v.soccer_others_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="soccer_others_account_min"
          :dirty="$v.soccer_others_account_min.$dirty"
          :error="$v.soccer_others_account_min.$error"
          :options="soccer_others_min_options"
          :value="soccer_others_account_min"
          @input="$v.soccer_others_account_min.$model = $event"
          :disabled="loading"
        )
    tr(v-if="['MMK','MMO'].includes($store.getters.getAccountCurrency) && !isEdit")
      th {{ $t("ui.sportsbook") + " MMO"}}
      th {{ hdp_mmo_title }}
      td
        PTSelect(
          ref="hdp_mmo_upline_pt"
          :dirty="$v.hdp_mmo_upline_pt.$dirty"
          :error="$v.hdp_mmo_upline_pt.$error"
          :options="hdp_mmo_upline_options"
          :value="hdp_mmo_upline_pt"
          @input="input_hdp_mmo_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="hdp_mmo_account_pt"
          :dirty="$v.hdp_mmo_account_pt.$dirty"
          :error="$v.hdp_mmo_account_pt.$error"
          :options="hdp_mmo_account_options"
          :value="hdp_mmo_account_pt"
          @input="input_hdp_mmo_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="hdp_mmo_upline_remaining"
          :dirty="$v.hdp_mmo_upline_remaining.$dirty"
          :error="$v.hdp_mmo_upline_remaining.$error"
          :options="hdp_mmo_account_options"
          :value="hdp_mmo_upline_remaining"
          @input="$v.hdp_mmo_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="hdp_mmo_account_min"
          :dirty="$v.hdp_mmo_account_min.$dirty"
          :error="$v.hdp_mmo_account_min.$error"
          :options="hdp_mmo_min_options"
          :value="hdp_mmo_account_min"
          @input="$v.hdp_mmo_account_min.$model = $event"
          :disabled="loading"
        )
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect
  },
  props: {
    loading: false,
    accountID: "",
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      soccer_hdp_upline_pt: 0,
      soccer_hdp_account_pt: 0,
      soccer_hdp_upline_remaining: 0,
      soccer_hdp_account_min: 0,
      soccer_1x2_upline_pt: 0,
      soccer_1x2_account_pt: 0,
      soccer_1x2_upline_remaining: 0,
      soccer_1x2_account_min: 0,
      soccer_others_upline_pt: 0,
      soccer_others_account_pt: 0,
      soccer_others_upline_remaining: 0,
      soccer_others_account_min: 0,
      hdp_mmo_upline_pt: 0,
      hdp_mmo_account_pt: 0,
      hdp_mmo_upline_remaining: 0,
      hdp_mmo_account_min: 0
    }
  },
  validations: {
    soccer_hdp_upline_pt: {
      required,
      minValue(value) {
        let total = 0
        if(this.$helpers.isAgentLevel()) {
          total = value
        } else {
          total = value + this.soccer_hdp_account_pt
        }
        if(total < this.soccer_hdp_upline_min) {
          return false
        } else {
          return true
        }
      }
    },
    soccer_hdp_account_pt: {
      required,
      minValue(value) {
        let total = 0
        if(this.$helpers.isAgentLevel()) {
          return true
        } else {
          total = value + this.soccer_hdp_upline_pt
          if(total < this.soccer_hdp_upline_min) {
            return false
          } else {
            return true
          }
        }
      }
    },
    soccer_hdp_upline_remaining: {
      required
    },
    soccer_hdp_account_min: {
      required
    },
    soccer_1x2_upline_pt: {
      required,
      minValue(value) {
        let total = 0
        if(this.$helpers.isAgentLevel()) {
          total = value
        } else {
          total = value + this.soccer_1x2_account_pt
        }
        if(total < this.soccer_1x2_upline_min) {
          return false
        } else {
          return true
        }
      }
    },
    soccer_1x2_account_pt: {
      required,
      minValue(value) {
        let total = 0
        if(this.$helpers.isAgentLevel()) {
          return true
        } else {
          total = value + this.soccer_1x2_upline_pt
          if(total < this.soccer_1x2_upline_min) {
            return false
          } else {
            return true
          }
        }
      }
    },
    soccer_1x2_upline_remaining: {
      required
    },
    soccer_1x2_account_min: {
      required
    },
    soccer_others_upline_pt: {
      required,
      minValue(value) {
        let total = 0
        if(this.$helpers.isAgentLevel()) {
          total = value
        } else {
          total = value + this.soccer_others_account_pt
        }
        if(total < this.soccer_others_upline_min) {
          return false
        } else {
          return true
        }
      }
    },
    soccer_others_account_pt: {
      required,
      minValue(value) {
        let total = 0
        if(this.$helpers.isAgentLevel()) {
          return true
        } else {
          total = value + this.soccer_others_upline_pt
          if(total < this.soccer_others_upline_min) {
            return false
          } else {
            return true
          }
        }
      }
    },
    soccer_others_upline_remaining: {
      required
    },
    soccer_others_account_min: {
      required
    },
    hdp_mmo_upline_pt: {
      required,
      minValue(value) {
        if(['MMK','MMO'].includes(this.$store.getters.getAccountCurrency) && !this.isEdit) {
          let total = 0
          if(this.$helpers.isAgentLevel()) {
            total = value
          } else {
            total = value + this.hdp_mmo_account_pt
          }
          if(total < this.hdp_mmo_upline_min) {
            return false
          } else {
            return true
          }
        } else {
          return minValue(0)(value)
        }
      }
    },
    hdp_mmo_account_pt: {
      required,
      minValue(value) {
        if(['MMK','MMO'].includes(this.$store.getters.getAccountCurrency) && !this.isEdit) {
          let total = 0
          if(this.$helpers.isAgentLevel()) {
            return true
          } else {
            total = value + this.hdp_mmo_upline_pt
            if(total < this.hdp_mmo_upline_min) {
              return false
            } else {
              return true
            }
          }
        } else {
          return minValue(0)(value)
        }
      }
    },
    hdp_mmo_upline_remaining: {
      required
    },
    hdp_mmo_account_min: {
      required
    }
  },
  computed: {
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    soccer_hdp_title: function () {
      return this.$t("ui.hdp") + "/" + this.$t("ui.ou") + "/" + this.$t("ui.oe") + " (" + this.soccer_hdp_upline_min + "%-" + this.soccer_hdp_upline_max + "%)"
    },
    soccer_hdp_upline_min: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'HDP', 'SOCCER', 'account_min')
    },
    soccer_hdp_upline_max: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'HDP', 'SOCCER', 'account_pt')
    },
    soccer_hdp_account_max: function() {
      return this.soccer_hdp_upline_max - this.soccer_hdp_upline_pt
    },
    soccer_hdp_upline_options: function() {
      return this.$helpers.getPTRateList(this.soccer_hdp_upline_max)
    },
    soccer_hdp_account_options: function() {
      return this.$helpers.getPTRateList(this.soccer_hdp_account_max)
    },
    soccer_hdp_min_options: function() {
      return this.$helpers.getPTRateList(this.soccer_hdp_account_pt)
    },
    soccer_1x2_title: function() {
      return this.$t("ui.oxt") + "/" + this.$t("ui.double_chance") + "/" + this.$t("ui.money_line") + " (" + this.soccer_1x2_upline_min + "%-" + this.soccer_1x2_upline_max + "%)"
    },
    soccer_1x2_upline_min: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, '1X2', 'SOCCER', 'account_min')
    },
    soccer_1x2_upline_max: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, '1X2', 'SOCCER', 'account_pt')
    },
    soccer_1x2_account_max: function() {
      return this.soccer_1x2_upline_max - this.soccer_1x2_upline_pt
    },
    soccer_1x2_upline_options: function() {
      return this.$helpers.getPTRateList(this.soccer_1x2_upline_max)
    },
    soccer_1x2_account_options: function() {
      return this.$helpers.getPTRateList(this.soccer_1x2_account_max)
    },
    soccer_1x2_min_options: function() {
      return this.$helpers.getPTRateList(this.soccer_1x2_account_pt)
    },
    soccer_others_title: function() {
      return this.$t("ui.others") + " (" + this.soccer_others_upline_min + "%-" + this.soccer_others_upline_max + "%)"
    },
    soccer_others_upline_min: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'OTHERS', 'SOCCER', 'account_min')
    },
    soccer_others_upline_max: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'OTHERS', 'SOCCER', 'account_pt')
    },
    soccer_others_account_max: function() {
      return this.soccer_others_upline_max - this.soccer_others_upline_pt
    },
    soccer_others_upline_options: function() {
      return this.$helpers.getPTRateList(this.soccer_others_upline_max)
    },
    soccer_others_account_options: function() {
      return this.$helpers.getPTRateList(this.soccer_others_account_max)
    },
    soccer_others_min_options: function() {
      return this.$helpers.getPTRateList(this.soccer_others_account_pt)
    },
    hdp_mmo_title: function() {
      return this.$t("ui.hdp") + "/" + this.$t("ui.ou") + " (" + this.hdp_mmo_upline_min + "%-" + this.hdp_mmo_upline_max + "%)"
    },
    hdp_mmo_upline_min: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'HDPMMO', 'SOCCER', 'account_min')
    },
    hdp_mmo_upline_max: function() {
      return this.$helpers.getPTSB(this.$store.getters.getPTSB, 'HDPMMO', 'SOCCER', 'account_pt')
    },
    hdp_mmo_account_max: function() {
      return this.hdp_mmo_upline_max - this.hdp_mmo_upline_pt
    },
    hdp_mmo_upline_options: function() {
      return this.$helpers.getPTRateList(this.hdp_mmo_upline_max)
    },
    hdp_mmo_account_options: function() {
      return this.$helpers.getPTRateList(this.hdp_mmo_account_max)
    },
    hdp_mmo_min_options: function() {
      return this.$helpers.getPTRateList(this.hdp_mmo_account_pt)
    }
  },
  mounted: function() {
    if(this.$helpers.isAgentLevel()) {
      this.$v.soccer_hdp_upline_pt.$model = this.soccer_hdp_upline_max
      this.$v.soccer_1x2_upline_pt.$model = this.soccer_1x2_upline_max
      this.$v.soccer_others_upline_pt.$model = this.soccer_others_upline_max
      if(['MMK','MMO'].includes(this.$store.getters.getAccountCurrency)) {
        this.$v.hdp_mmo_upline_pt.$model = this.hdp_mmo_upline_max
      }
    }
  },
  methods: {
    input_soccer_hdp_upline_pt(e) {
      this.$v.soccer_hdp_upline_pt.$model = e
      this.$v.soccer_hdp_account_pt.$model = this.soccer_hdp_account_max

      if (this.soccer_hdp_upline_remaining > this.soccer_hdp_account_max) {
        this.$v.soccer_hdp_upline_remaining.$model = 0
      }
      if (this.soccer_hdp_account_min > this.soccer_hdp_account_pt) {
        this.$v.soccer_hdp_account_min.$model = 0
      }
      this.$emit("clicked")
    },
    input_soccer_hdp_account_pt(e) {
      this.$v.soccer_hdp_account_pt.$model = e
      if (this.soccer_hdp_account_min > this.soccer_hdp_account_pt) {
        this.$v.soccer_hdp_account_min.$model = 0
      }
      this.$emit("clicked")
    },
    input_soccer_hdp_upline_remaining(e) {
      this.$v.soccer_hdp_upline_remaining.$model = e
      this.$emit("clicked")
    },
    input_soccer_hdp_account_min(e) {
      this.$v.soccer_hdp_account_min.$model = e
      this.$emit("clicked")
    },
    input_soccer_1x2_upline_pt(e) {
      this.$v.soccer_1x2_upline_pt.$model = e
      this.$v.soccer_1x2_account_pt.$model = this.soccer_1x2_account_max
      if (this.soccer_1x2_upline_remaining > this.soccer_1x2_account_max) {
        this.$v.soccer_1x2_upline_remaining.$model = 0
      }
      if (this.soccer_1x2_account_min > this.soccer_1x2_account_max) {
        this.$v.soccer_1x2_account_min.$model = 0
      }
    },
    input_soccer_1x2_account_pt(e) {
      this.$v.soccer_1x2_account_pt.$model = e
      if (this.soccer_1x2_account_min > this.soccer_1x2_account_pt) {
        this.$v.soccer_1x2_account_min.$model = 0
      }
    },
    input_soccer_others_upline_pt(e) {
      this.$v.soccer_others_upline_pt.$model = e
      this.$v.soccer_others_account_pt.$model = this.soccer_others_account_max
      if (this.soccer_others_upline_remaining > this.soccer_others_account_max) {
        this.$v.soccer_others_upline_remaining.$model = 0
      }
      if (this.soccer_others_account_min > this.soccer_others_account_max) {
        this.$v.soccer_others_account_min.$model = 0
      }
    },
    input_soccer_others_account_pt(e) {
      this.$v.soccer_others_account_pt.$model = e
      if (this.soccer_others_account_min > this.soccer_others_account_pt) {
        this.$v.soccer_others_account_min.$model = 0
      }
    },
    input_hdp_mmo_upline_pt(e) {
      this.$v.hdp_mmo_upline_pt.$model = e
      this.$v.hdp_mmo_account_pt.$model = this.hdp_mmo_account_max
      if (this.hdp_mmo_upline_remaining > this.hdp_mmo_account_max) {
        this.$v.hdp_mmo_upline_remaining.$model = 0
      }
      if (this.hdp_mmo_account_min > this.hdp_mmo_account_max) {
        this.$v.hdp_mmo_account_min.$model = 0
      }
    },
    input_hdp_mmo_account_pt(e) {
      this.$v.hdp_mmo_account_pt.$model = e
      if (this.hdp_mmo_account_min > this.hdp_mmo_account_pt) {
        this.$v.hdp_mmo_account_min.$model = 0
      }
    }
  }
}

</script>